import React, { FC, memo } from "react";
import { ButtonProps, Button, forwardRef } from "@chakra-ui/react";
import colors from "app/colors";
import { PlusIcon } from "modules/icons";

const AddItemButton: FC<ButtonProps> = forwardRef<ButtonProps, "button">(
  ({ children, ...rest }, ref) => (
    <Button
      ref={ref}
      variant="ghost"
      color={colors.blue}
      p={1}
      h="unset"
      fontSize={12}
      leftIcon={<PlusIcon boxSize={4} fill={colors.blue} />}
      iconSpacing={1}
      {...rest}
    >
      {children}
    </Button>
  ),
);

export default memo(AddItemButton);
